import React from "react";
import { WorldIcon } from "../../../../styles/img/svg/WorldIcon";
import UserImage from '../../../../styles/img/user.jpg'
import GoogleImage from '../../../../styles/img/google-img-icon.png'
import { SchoolIcon } from "../../../../styles/img/svg/SchoolIcon";
import { CommaDown, CommaUp } from "../../../../styles/img/svg/Comma";
import { PencilIcon } from "../../../../styles/img/svg/PencilIcon";

export const UiProfileInfo = () => {
    return (
        <>
            <div className="sb-prof-expanded">
                <div className="sb-prof-expanded__header">
                    <div className="sb-prof-expanded__header-wrapper">
                        <img src={UserImage} />
                        <div className="sb-prof-expanded__edit-btn">
                            <PencilIcon />
                        </div>
                    </div>
                    <span className="sb-prof-expanded__edit-profile">Edit Profile</span>
                </div>

                <div className="sb-prof-expanded__body">
                    <div className="sb-prof-expanded__personal-inf">
                        <h3>Nick Chandarana</h3>
                        <h5>@nickc<span>3.3k points</span></h5>

                        {/* <div className="sb-prof-expanded__sb-prof-inf-card">
                            <h6>6</h6>
                            <p>CURRENT INCENTIVES</p>
                        </div>

                        <div className="sb-prof-expanded__sb-prof-inf-card">
                            <h6>15</h6>
                            <p>badges</p>
                        </div>

                        <div className="sb-prof-expanded__sb-prof-inf-card">
                            <h6>2</h6>
                            <p>notifications</p>
                        </div>

                        <div className="sb-prof-expanded__sb-prof-inf-card">
                            <button>Employee Profile</button>
                        </div>

                        <div className="sb-prof-expanded__sb-prof-inf-card">
                            <h5>3.3k points</h5>
                        </div> */}
                    </div>

                    <div className="sb-prof-expanded__about-inf">
                        <h4>About
                            <div className="sb-prof-expanded__edit-btn">
                                <PencilIcon />
                            </div></h4>
                        <div className="sb-prof-expanded__inf-card">
                            <WorldIcon />
                            <div>
                                <p>London, England</p>
                                <a href="mailto:name.surname@company.com">name.surname@company.com</a>
                                <a href="tel:07777 111222">07777 111222</a>
                            </div>
                        </div>
                    </div>

                    {/* <div className="sb-prof-expanded__about-inf">
                        <h4>Experience
                            <div className="sb-prof-expanded__edit-btn">
                                <PencilIcon />
                            </div>
                        </h4>
                        <div className="sb-prof-expanded__inf-card sb-prof-expanded__inf-exp">
                            <img src={GoogleImage} />
                            <div>
                                <p>Google</p>
                                <p>Car Sales London East</p>
                                <p>March 2022 - November 2022</p>
                            </div>
                        </div>
                        <p>laboris nisi ut aliquip ex ea commodo. Ut enim ad minim veniam.</p>
                    </div>


                    <div className="sb-prof-expanded__about-inf">
                        <h4>Education
                            <div className="sb-prof-expanded__edit-btn">
                                <PencilIcon />
                            </div>
                        </h4>
                        <div className="sb-prof-expanded__inf-card">
                            <WorldIcon />
                            <div>
                                <p>Sales & Marketing Course, London, England</p>
                            </div>
                        </div>

                        <div className="sb-prof-expanded__inf-card">
                            <SchoolIcon />
                            <div>
                                <p>The University of London</p>
                            </div>
                        </div>
                    </div> */}

                    {/* <div className="sb-prof-expanded__about-inf">
                        <h4>Interests
                            <div className="sb-prof-expanded__edit-btn">
                                <PencilIcon />
                            </div>
                        </h4>
                        <div className="sb-prof-expanded__inf-card sb-prof-expanded__interest-card">
                            <CommaUp />
                            <p>laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                            <CommaDown />
                        </div>

                    </div> */}

                    <div className="sb-prof-expanded__about-inf">
                        <h4>Update Password
                            <div className="sb-prof-expanded__edit-btn">
                                <PencilIcon />
                            </div>
                        </h4>
                        <div className="sb-prof-expanded__inf-card sb-prof-expanded__inf-card-password">
                            <p>laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim. </p>
                            <div>
                                <button>Current Password</button>
                                <button>      New Password     </button>
                                <button>Current Password</button>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </>
    )
}